import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import GUI from "lil-gui";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { HDRLoader } from "three/examples/jsm/loaders/HDRLoader.js";
import { EXRLoader } from "three/examples/jsm/loaders/EXRLoader.js";
import { GroundedSkybox } from "three/examples/jsm/objects/GroundedSkybox.js";


/**
 * Loaders
 */
const modelLoader = new GLTFLoader();
const cubeTextureLoader = new THREE.CubeTextureLoader();
const hdrLoader = new HDRLoader();
const exrLoader = new EXRLoader();
const textureLoader = new THREE.TextureLoader();

/**
 * Base
 */
// Debug
const gui = new GUI();

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Environment Map
 */
scene.environmentIntensity = 1
scene.backgroundBlurriness = 0
scene.backgroundIntensity = 1

// scene.backgroundRotation.x = 1
// scene.environmentRotation.x = 1

gui.add(scene, "environmentIntensity").min(0).max(10).step(0.001).name("Environment Intensity");
gui.add(scene, "backgroundBlurriness").min(0).max(1).step(0.001).name("Background Blurriness");
gui.add(scene, "backgroundIntensity").min(0).max(10).step(0.001).name("Background Intensity");
gui.add(scene.backgroundRotation, "y").min(0).max(Math.PI * 2).step(0.001).name("Background Rotation Y");
gui.add(scene.environmentRotation, "y").min(0).max(Math.PI * 2).step(0.001).name("Environment Rotation Y");

// LDR cube texture
// const environmentMap = cubeTextureLoader.load([
//   "/24-environment-map/environmentMaps/0/px.png",
//   "/24-environment-map/environmentMaps/0/nx.png",
//   "/24-environment-map/environmentMaps/0/py.png",
//   "/24-environment-map/environmentMaps/0/ny.png",
//   "/24-environment-map/environmentMaps/0/pz.png",
//   "/24-environment-map/environmentMaps/0/nz.png",
// ]);

// scene.environment = environmentMap;
// scene.background = environmentMap;

// HDR (RGBE) equirectangular environment map
// hdrLoader.load("/24-environment-map/environmentMaps/blender-2k.hdr", (envMap) => {
//   envMap.mapping = THREE.EquirectangularReflectionMapping;
//   scene.environment = envMap;
//   // scene.background = envMap;
// })


// HDR (EXR) equirectangular environment map
// exrLoader.load("/24-environment-map/environmentMaps/nvidiaCanvas-4k.exr", (envMap) => {
//   envMap.mapping = THREE.EquirectangularReflectionMapping;
//   scene.environment = envMap;
//   scene.background = envMap;
// })

// LDR Equirectangular environment map
// const envMap = textureLoader.load("/24-environment-map/environmentMaps/blockadesLabsSkybox/interior_views_cozy_wood_cabin_with_cauldron_and_p.jpg");
// envMap.mapping = THREE.EquirectangularReflectionMapping;
// envMap.colorSpace = THREE.SRGBColorSpace;
// scene.environment = envMap;
// scene.background = envMap;

// Ground projected sky box
// hdrLoader.load("/24-environment-map/environmentMaps/2/2k.hdr", (envMap) => {
//   envMap.mapping = THREE.EquirectangularReflectionMapping;
//   scene.environment = envMap;
  
//   const skybox = new GroundedSkybox(envMap, 15, 70);
//   skybox.position.y = 15;
//   scene.add(skybox);
// })

/**
 * Real time environment map
 */
const envMap = textureLoader.load("/24-environment-map/environmentMaps/blockadesLabsSkybox/interior_views_cozy_wood_cabin_with_cauldron_and_p.jpg");
envMap.mapping = THREE.EquirectangularReflectionMapping;
envMap.colorSpace = THREE.SRGBColorSpace;
// scene.environment = envMap;
scene.background = envMap;

// Holy Donut
const holyDonut = new THREE.Mesh(
  new THREE.TorusGeometry(8, 0.5),
  new THREE.MeshBasicMaterial({
    color: new THREE.Color(10, 4, 2),
  }),
);
holyDonut.position.y = 3.5;
holyDonut.layers.enable(1);
scene.add(holyDonut);

// Cube render target
const cubeRenderTarget = new THREE.WebGLCubeRenderTarget(256, {
  type: THREE.HalfFloatType,
});

scene.environment = cubeRenderTarget.texture;

// Cube camera
const cubeCamera = new THREE.CubeCamera(0.1, 100, cubeRenderTarget)
cubeCamera.layers.set(1);

/**
 * Torus Knot
 */
const torusKnot = new THREE.Mesh(
  new THREE.TorusKnotGeometry(1, 0.4, 100, 16),
  new THREE.MeshStandardMaterial({
    roughness: 0,
    metalness: 1,
    color: "#aaaaaa",
  }),
);
torusKnot.position.x = -4;
torusKnot.position.y = 4;
scene.add(torusKnot);

/**
 * Models
 */
modelLoader.load(
  "/24-environment-map/models/FlightHelmet/glTF/FlightHelmet.gltf",
  (gltf) => {
    gltf.scene.scale.set(10, 10, 10);
    scene.add(gltf.scene);
  },
);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100,
);
camera.position.set(4, 5, 4);
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.target.y = 3.5;
controls.enableDamping = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Animate
 */
const clock = new THREE.Clock();
const tick = () => {
  // Time
  const elapsedTime = clock.getElapsedTime();

  // Real time environment map
  if(holyDonut) {
    holyDonut.rotation.x = Math.sin(elapsedTime) * 2;

    cubeCamera.update(renderer, scene);
  }

  // Update controls
  controls.update();

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
